import EntitiesTable from './EntitiesTable';

export default EntitiesTable;
